export default {
  // ReportedTask.vue translations
  addMember: "Add Member",
  email: "Email",
  emailExistsError:
    "This email is already registered. Please use another email.",
  generalError: "An error occurred while submitting. Please try again later.",
  invalidCompanyIdOrUserId: "Invalid Company ID or User ID.",
  routineTaskDeleted: "Routine Task deleted successfully.",
  routineTaskAdded: "Routine Task added successfully.",
  deleteConfirmationTitle: "Delete Routine Task",
  deleteConfirmationText: "Are you sure you want to delete this Routine Task?",
  delete: "Delete",
  addRoutineTask: "Add Routine Task",
  routineTaskName: "Routine Task Name",
  description: "Description",
  close: "Close",
  create: "Create",
  reportedTasksTable: "Reported Routine Tasks",
  routineTaskNameRequired: "Please enter the routine task name.",
  routineTaskAddedError:
    "An error occurred while adding the routine task. Please try again later.",
  from: "From",
  to: "To",
  routineTaskManager: "Routine Task Manager",
  assignManager: "Assign Manager",
  enterDescription: "Enter Description",
  enterRoutineTaskName: "Enter Routine Task Name",
  createRoutineTask: "Create Routine Task",
  saving: "Saving...",
  noRoutineTasks: "No routine tasks found.",
  createee: "Create your routine task ",
  inactive: "Inactive",
  active: "Active",
  advancedSettings: "Advanced Settings",
  taskNumber: "Task Number",
  taskType: "Task Type",
  selectTaskType: "Select Task Type",
  recurrentDays: "Recurrent Days",
  enterRecurrentDays: "Enter number of recurrent days",
  dayOfMonth: "Day of Month",
  enterDayOfMonth: "Enter day of the month ex: 1, 2,....31",
  department: "Department",
  selectDepartment: "Select Department",
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  enterStartDate: "Enter start date",
  startDate: "Start Date",
  status: "Status",
  allTypes: "All Types",
  allStatuses: "All Statuses",
  allDepartments: "All Departments",
  weekly: "Weekly",
  monthly: "Monthly",
  last_day_of_month: "Last Day of Month",
  daily: "Daily",
  applyFilters: "Apply Filters",
  resetFilters: "Reset Filters",
  selectAll: "Select All",
  departmentsSelected: "Departments Selected",
  filterByDate: "Filter by Date",
  reported: "Reported",
  not_reported: "Not Reported",
  searchPlaceholder: "Search tasks...",
  evaluated_Task: "Evaluated Tasks",
  done: "Done",
  notDone: "Not Done",
  clearAll: "Clear All",

  // ReportedTaskTable.vue translations
  tasksTable: "Tasks Table",
  taskName: "Task Name",
  edit: "Edit",
  deleteConfirmationSuccess: "Task deleted successfully.",
  update: "Update",
  taskUpdatedSuccessfully: "Task updated successfully",
  taskDeletedSuccessfully: "Task deleted successfully",
  taskReportedSuccessfully: "Task reported successfully",
  taskCreatedBy: "Created By",
  taskDetails: "Task Details",
  createdAt: "Task Created At",
  deadline: "Deadline",
  log: "Log",
  info: "Info",
  statusUpdatedSuccessfully: "Status updated successfully",
  errorUpdatingStatus: "Error updating status",
  errorUpdatingTask: "Error updating task",
  errorDeletingTask: "Error deleting task",
  noLogsAvailable: "No logs available",
  changedTheField: "changed the field",
  onDate: "On",
  editTask: "Edit Task",
  noTasks: "No tasks found.",
  taskStartDate: "Task Start Date",
  taskDeadline: "Task Deadline",
  reportTaskType: "Report Task Type",
  dayOfWeek: "Day of Week",
  fromTime: "From Time",
  taskCreatedSuccessfully: "Task created successfully",
  taskCreatedSuccessfullyMessage: "Task created successfully",
  taskCreationError: "Error creating task",
  report: "Report",
  reportTask: "Report Task",
  selectReportTaskType: "Select Report Task Type",
  notes: "Notes",
  taskStatus: "Task Status",
  notReported: "Not Reported",
  enterNotes: "Enter notes",
  employeeName: "Employee Name",
  at: "at",
  reporttime: "Report Time",
  lateTime: "Late Time",
  fromDate: "From Date",
  toDate: "To Date",
  applyFilter: "Apply Filter",
  found: "Task Found",
  evaluation: "Evaluation",
  evaluate: "Evaluate",
  evaluatedAt: "Evaluated At",
  evaluatedBy: "Evaluated By",
  reportedBy: "Reported By",
  evaluated: "Evaluated",
  taskFound: "There is task ?",
  selectTaskFound: "Select Task Found",
  project: "Project",
  projectNotFound: "No project found",
  rating: "Rating",
  comment: "Comment",
  elvatedAllready: "this task is evaluated already",
  priority: "Priority",
  randomTask: "random task to evaluate",
  selectDate: "Select Date",
};
